import { render, staticRenderFns } from "./edit-player.vue?vue&type=template&id=13866023&scoped=true&"
import script from "./edit-player.vue?vue&type=script&lang=js&"
export * from "./edit-player.vue?vue&type=script&lang=js&"
import style0 from "./edit-player.vue?vue&type=style&index=0&id=13866023&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13866023",
  null
  
)

export default component.exports